export const ZapIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.4711 9.5052H6.12688C5.01409 9.5052 4.45768 9.5052 4.22052 9.1383C3.98335 8.77147 4.20933 8.26035 4.66128 7.23812L6.02001 4.16492C6.43093 3.2355 6.63639 2.77078 7.03498 2.51039C7.43356 2.25 7.93942 2.25 8.95125 2.25H10.5183C11.7474 2.25 12.3619 2.25 12.5937 2.65151C12.8255 3.05303 12.5206 3.58941 11.9108 4.66217L11.1069 6.07641C10.8037 6.60971 10.6522 6.87637 10.6543 7.09464C10.657 7.37831 10.8079 7.63965 11.0515 7.78275C11.239 7.89292 11.5445 7.89293 12.1555 7.89293C12.928 7.89293 13.3142 7.89292 13.5154 8.02665C13.7767 8.20035 13.9135 8.51115 13.8655 8.8224C13.8286 9.06195 13.5688 9.3492 13.0492 9.92377L8.89792 14.5142C8.08252 15.4159 7.67482 15.8667 7.40105 15.7241C7.12727 15.5813 7.25875 14.9867 7.52167 13.7972L8.03677 11.4672C8.23695 10.5615 8.33707 10.1087 8.09632 9.80693C7.85557 9.5052 7.39408 9.5052 6.4711 9.5052Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);
